export function getRuntimeGlobalState(options) {
    try {
        const GlobalStateManager = require("@carousel-office/agent-runtime/global-state/globalStateManager").default;
        const runtime = GlobalStateManager?.getInstance?.();
        if (!runtime) {
            if (options?.fallback) {
                return options.fallback;
            }
            throw new Error("Runtime global state is unavailable.");
        }
        return runtime;
    }
    catch {
        if (options?.fallback) {
            return options.fallback;
        }
        throw new Error("Runtime global state is unavailable.");
    }
}
export function ensureRuntimeConversation(options) {
    const { globalState, conversationId, documentId, origin = "mainTaskpane" } = options;
    const existing = globalState.getConversation(conversationId);
    if (existing) {
        return existing;
    }
    return globalState.createConversation(conversationId, documentId, origin);
}
export function beginRuntimeConversationExecution(options) {
    const conversation = ensureRuntimeConversation({
        globalState: options.globalState,
        conversationId: options.conversationId,
        documentId: options.documentId,
        origin: options.origin,
    });
    const registry = conversation?.agentRegistry;
    const threadManager = registry?.threadManager;
    if (!registry?.createTask || !registry?.updateStatus) {
        throw new Error("Conversation agent registry is unavailable.");
    }
    if (options.cancelStatuses && options.cancelStatuses.length > 0) {
        cancelConversationTasks(registry, options.conversationId, options.cancelStatuses);
    }
    const { taskId, threadId } = registry.createTask({
        agentType: options.agentType,
        agentName: options.agentName,
        conversationId: options.conversationId,
        documentId: conversation?.documentId ?? options.documentId,
    });
    registry.updateStatus(taskId);
    return {
        conversation,
        registry,
        threadManager,
        taskId,
        threadId,
    };
}
export function getConversationPersistenceService() {
    const { getConversationPersistence } = require("@carousel-office/agent-runtime/persistence");
    return getConversationPersistence();
}
export function getRuntimeContextResolver() {
    const { getContextResolver } = require("@carousel-office/agent-runtime/core/contextResolver");
    return getContextResolver();
}
export function getConversationTasksByStatus(agentRegistry, conversationId, statuses) {
    if (!agentRegistry?.getTasksForConversation || !statuses.length) {
        return [];
    }
    const statusSet = new Set(statuses);
    return (agentRegistry.getTasksForConversation(conversationId) || []).filter((task) => statusSet.has(String(task.status || "")));
}
export function cancelConversationTasks(agentRegistry, conversationId, statuses = ["running", "pending"]) {
    if (!agentRegistry?.cancelTask) {
        return [];
    }
    const tasks = getConversationTasksByStatus(agentRegistry, conversationId, statuses);
    for (const task of tasks) {
        agentRegistry.cancelTask(task.taskId);
    }
    return tasks;
}
